import gameApi from 'api/gameApi';
import { useAppDispatch } from 'app/hooks';
import useUserDetail from 'hooks/useUserDetail';
import { GameResponseModel } from 'models';
import { FC, useCallback, useState } from 'react';
import { formatCompactNumber } from 'utils/formatAmount';
import { onChangeAuthPage } from '../homeSlice';
import { useNavigate } from 'react-router-dom';
import { PlayCircleFilled } from '@ant-design/icons';

type ReactionButtonProps = {
  game: GameResponseModel;
};

const ReactionButton: FC<ReactionButtonProps> = ({ game }) => {
  const { isUserLoggedIn } = useUserDetail();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [likeState, setLikeState] = useState({
    isLiked: game.isLiked,
    likedCounter: game.likedCounter,
    isDisliked: game.isDisliked,
    dislikedCounter: game.dislikedCounter,
  });

  const likeGame = useCallback(async () => {
    checkIsLogin();
    const { ok } = await gameApi.likeGame(game.id);
    if (ok) {
      setLikeState((prev) => ({
        isLiked: !prev.isLiked,
        likedCounter: prev.isLiked ? prev.likedCounter - 1 : prev.likedCounter + 1,
        isDisliked: false,
        dislikedCounter: prev.isDisliked ? prev.dislikedCounter - 1 : prev.dislikedCounter,
      }));
    }
  }, [game.id, likeState, isUserLoggedIn]);

  const dislikeGame = useCallback(async () => {
    checkIsLogin();
    const { ok } = await gameApi.dislikeGame(game.id);
    if (ok) {
      setLikeState((prev) => ({
        isLiked: false,
        likedCounter: prev.isLiked ? prev.likedCounter - 1 : prev.likedCounter,
        isDisliked: !prev.isDisliked,
        dislikedCounter: prev.isDisliked ? prev.dislikedCounter - 1 : prev.dislikedCounter + 1,
      }));
    }
  }, [game.id, likeState, isUserLoggedIn]);

  const checkIsLogin = () => {
    if (!isUserLoggedIn) {
      dispatch(onChangeAuthPage(0));
    }
  };

  return (
    <div className="reaction-button">
      <button onClick={likeGame} className={likeState.isLiked ? 'active' : ''}>
        ❤️<span>{formatCompactNumber(30 + likeState.likedCounter)}</span>
      </button>
      <button className={likeState.isDisliked ? 'active' : ''} onClick={dislikeGame}>
        🖕<span>{formatCompactNumber(3 + likeState.dislikedCounter)}</span>
      </button>
      {game.status === 'LIVE' && (
        <div
          className="watch-now cursor-pointer"
          onClick={() => {
            navigate('/live-game', { state: { game } });
          }}
        >
          <PlayCircleFilled />
          <p>Watch now</p>
        </div>
      )}
    </div>
  );
};

export default ReactionButton;
